import { render, staticRenderFns } from "./ElementStudioVariableOptions.vue?vue&type=template&id=b0525812&"
import script from "./ElementStudioVariableOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioVariableOptions.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioVariableOptions.vue?vue&type=style&index=0&id=b0525812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports